// used for temp account name prefix when crate account
export const TEMP_NAME_PREFIX = '_DMC_TEMP_';
export const UP_TEMP_NAME_PREFIX = '_UP_TEMP_';
export const PMAX_TEMP_NAME_PREFIX = '_PMAX_TEMP_';
